<template>
  <modal-template ref="modal" :title="title" type-modal="customers_modal">
    <div class="modal-content__main">
      <d-form>
        <d-form-row style="margin-bottom: 10px;">
          <d-col md="6" class="form-group">
            <autocomplete
            ref="autocomplete"
            placeholder="Adicione um cliente..."
            :items="customers.list"
            item-show="name"
            :on-input="onInput"
            :on-select="setCustomer"
            :on-blur="setCustomerBlur"
            >
            </autocomplete>
          </d-col>
          <d-col md="4" class="form-group">
            <d-button class="btn-success add-btn" @click.prevent="saveSelectedCustomer(selectedCustomer)">
              Adicionar cliente
            </d-button>
          </d-col>
        </d-form-row>
        <div class="card-body p-0 pb-3 text-left">
          <d-row class="row-table">
            <d-col class="col-table" style=" max-height: 55vh; overflow-y:auto;">
              <!-- Customer table -->
              <table class="table mb-0 table-striped">
                <tbody>
                  <tr v-for="(customer, index) in displayCustomers" :key="index" class="align-items-center">
                    <td class="align-middle">{{ customer.name }}</td>
                    <td class="align-middle">{{ customer.email }}</td>
                    <td class="align-middle">
                      <d-button-group class="align-middle">
                        <d-button size="sm" class="btn-danger" @click.prevent="deleteCustomer(customer)">
                          <i class="fas fa-trash"></i>
                          <span class="d-none d-lg-inline delete-span">Excluir</span>
                        </d-button>
                      </d-button-group>
                    </td>
                  </tr>
                  <tr v-if="displayCustomers.length === 0">
                    <td colspan="7" class="no-content">Não há clientes registrados ainda.</td>
                  </tr>
                </tbody>
              </table>
            </d-col>
          </d-row>
        </div>
      </d-form>
    </div>
    <div slot="actions" class="modal-content__control">
      <button type="button" class="btn btn-sm btn-primary" @click.prevent="cancel()">Fechar</button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import UserService from '_services/rest/modules/user';
import ModalTemplate from '_shared/Modal.vue';
import Autocomplete from '_shared/Autocomplete.vue';
import { _SAVE_MODEL_ } from '../UserModel';

export default {
  name: 'customers-modal',
  components: {
    ModalTemplate,
    Autocomplete,
  },
  computed: {
    customers() {
      const { customerList } = this.$store.state.customer;
      if (customerList && customerList.list.length) {
        return customerList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
    isCustomer() {
      const { isCustomer } = this.$store.state.user;
      return isCustomer;
    },
    userCustomersList() {
      const { userCustomersList } = this.$store.state.user;
      if (userCustomersList) {
        return userCustomersList;
      }
      return [];
    },
    displayCustomers() {
      const list = this.userId ? this.userCustomersList : this.tempCustomers;
      return list;
    },
  },
  data() {
    return {
      tempCustomers: [],
      loading: false,
      customerSelected: null,
      userId: parseInt(this.$route.params.userId, Number),
      title: 'Clientes',
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'getCustomerList',
      'getUserCustomersList',
    ]),
    cancel() {
      this.setToggle({ type: 'customers_modal', bool: false });
    },
    toggleLoading() {
      this.loading = !this.loading;
      Events.$emit('loading', this.loading);
    },
    onInput(name) {
      clearTimeout(this.searchTimeoutId);
      this.searchTimeoutId = setTimeout(() => {
        this.getCustomers(name);
      }, 500);
    },
    getCustomers(name = '') {
      this.toggleLoading();
      const params = {
        skip: 0,
        take: 10,
        search: name,
      };
      this.getCustomerList(params)
        .then(() => {
          this.toggleLoading();
        });
    },
    setCustomer(customer) {
      this.selectedCustomer = customer;
    },
    setCustomerBlur(customer) {
      this.selectedCustomer = customer;
    },
    loadUserCustomersList(userId) {
      if (userId) {
        this.getUserCustomersList(userId);
      }
    },
    loadLists() {
      this.tempCustomers = [];
      this.loadUserCustomersList(this.userId);
    },
    saveSelectedCustomer(customer) {
      if (!customer || customer.id === undefined) {
        this.activeAlert({ message: 'Selecione um cliente', theme: 'danger' });
        return;
      }

      if (!this.userId) {
        this.addTempCustomer(customer);
      } else {
        this.saveCustomerToUser(customer);
      }
      this.selectedCustomer = null;
      if (this.$refs.autocomplete) {
        this.$refs.autocomplete.clear();
      }
    },
    addTempCustomer(customer) {
      const { id } = customer;
      const existsInTemp = this.tempCustomers.some(tempCustomer => tempCustomer.id === id);
      const message = existsInTemp ? 'Cliente já foi adicionado' : null;
      if (message) this.activeAlert({ message, theme: 'danger' });
      else this.tempCustomers.push(customer);
    },
    saveCustomerToUser(customer) {
      const ids = {
        user_id: this.userId,
        customer_id: customer.id,
      };
      UserService.saveUserCustomer(ids)
        .then(() => {
          this.loadUserCustomersList(this.userId);
          this.activeAlert({ message: 'Cliente adicionado com sucesso', theme: 'success' });
        })
        .catch(response => this.activeAlert({ message: response.message, theme: 'danger' }));
    },
    saveTempCustomers(userData) {
      const userId = userData.data.id;

      const saveCustomer = customer => {
        const ids = {
          user_id: userId,
          customer_id: customer.id,
        };
        UserService.saveUserCustomer(ids);
      };

      try {
        this.tempCustomers.map(saveCustomer);
        this.loadUserCustomersList(userId);
        this.tempCustomers = [];
      } catch (error) {
        this.activeAlert({ message: `Erro ao salvar clientes: ${error.message}`, theme: 'danger' });
      }
    },
    deleteCustomer(customer) {
      const { id: customerId } = customer;

      if (!this.userId) {
        this.removeTempCustomer(customerId);
      } else {
        this.removeUserCustomer(this.userId, customerId);
      }
    },
    removeTempCustomer(customerId) {
      const index = this.tempCustomers.findIndex(c => c.id === customerId);
      if (index !== -1) {
        this.tempCustomers.splice(index, 1);
        this.activeAlert({ message: 'Cliente removido com sucesso', theme: 'success' });
      }
    },
    removeUserCustomer(userId, customerId) {
      try {
        UserService.deleteUserCustomer({ user_id: userId, customer_id: customerId })
          .then(() => {
            this.loadUserCustomersList(userId);
            this.activeAlert({ message: 'Cliente removido com sucesso', theme: 'success' });
          });
      } catch (error) {
        this.activeAlert({ message: `Erro ao deletar cliente: ${error.message}`, theme: 'danger' });
      }
    },
  },
  mounted() {
    this.loadLists();
    if (!this.userId) {
      Events.$on(_SAVE_MODEL_, this.saveTempCustomers);
    }
  },
};
</script>

<style lang="scss" scoped>
.form-group {
  display: flex;
  align-items: center;
}

@media (max-width: 767px) {
  .form-group {
    justify-content: center;
  }
}

.add-btn {
  padding: 10px;
  font-size: 13px;
}

.align-middle {
  vertical-align: middle;
}

.delete-span {
  margin-left: 5px;
}
</style>
